<script>
	const Q = require('q');
	const page = require('page');
	const _ = require('underscore');
	const utilities = require('utilities');
	const scrollManager = require('ui/core/scrollManager');
	const model = require('model/model');
	const SKILanguages = require('../../../../../../lib/SKILanguages');
	const i18n = require('i18n/i18n');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SKI_STUDENT_ANSWER_QUESTION = analyticsUtilities.events.SKI_STUDENT_ANSWER_QUESTION;
	const SKI_START = analyticsUtilities.events.SKI_START;
	const WORKSPACE_TOOL_CLICK = analyticsUtilities.events.WORKSPACE_TOOL_CLICK;
	const PRINT = analyticsUtilities.events.PRINT;

	const studentKnowledgeInventoryUtilities = require('utilities/studentKnowledgeInventoryUtilities');
	const getSKIProduct = studentKnowledgeInventoryUtilities.getSKIProduct;
	const studentGetSKIAssignment = studentKnowledgeInventoryUtilities.studentGetSKIAssignment;
	const submitSKI = studentKnowledgeInventoryUtilities.submitSKI;

	const { authenticateWithGoogleClassroom } = require('utilities/googleClassroomUtilities');

	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		components: {
			'survey-question': require('components/survey-question.vue').default,
			'text-to-speech-player-simple': require('components/text-to-speech-player-simple.vue').default,
			'audio-player-simple': require('components/audio-player-simple.vue').default,
			'load-mask': require('components/load-mask.vue').default
		},
		modelData: ['skiProduct', 'skiAssignment', 'userContext', 'classCode', 'skiWorkspaceBack', 'localGCAccessToken'],
		data() {
			return {
				loading: false,
				answers: {},
				submitted: false,
				numberOfQuestions: null,
				allQuestions: null,
				sections: null,
				showTts: false,
				selectedLanguage: null
			};
		},
		computed: {
			title() {
				let skiProduct = this.skiProduct;
				let title = 'Student Survey';

				if (skiProduct && skiProduct.title) {
					title = skiProduct.title;
				}

				return title;
			},
			questionTypes() {
				let skiProduct = this.skiProduct;
				let types = {};

				if (skiProduct && skiProduct.questionTypes) {
					types = skiProduct.questionTypes;
				}

				return types;
			},
			postSubmissionData() {
				let skiProduct = this.skiProduct;
				let data = {};

				if (skiProduct && skiProduct.postSubmissionText) {
					data = {
						text: skiProduct.postSubmissionText,
						audio: skiProduct.postSubmissionAudio
					};
				}

				return data;
			},
			numberOfQuestionsAnswered() {
				let answers = this.answers;
				let count = 0;
				for (let key in answers) {
					if (answers[key]) {
						count++;
					}
				}
				return count;
			},
			hasUnansweredQuestions() {
				let answers = this.answers;
				let allQuestions = this.allQuestions;
				let unanswered = false;

				if (allQuestions) {
					let qids = Object.keys(allQuestions);
					unanswered = !qids.every(qid => {
						let q = allQuestions[qid];
						return !q.required || answers[qid] !== null;
					});
				}

				return unanswered;
			},
			unansweredQuestionsData() {
				let skiProduct = this.skiProduct;
				let data = {};

				if (skiProduct && skiProduct.unansweredQuestionsText) {
					data = {
						text: skiProduct.unansweredQuestionsText,
						audio: skiProduct.unansweredQuestionsAudio
					};
				}

				return data;
			},
			hasAssignment() {
				let userContext = this.userContext;
				let assignmentLoaded = false;

				// Teachers can only view workspace by clicking on the assignment.
				if (!userContext.classCode) {
					assignmentLoaded = true;
				} else {
					assignmentLoaded = !!this.skiAssignment;
				}

				return assignmentLoaded;
			},
			isTeacher() {
				let userContext = this.userContext;
				return !userContext.classCode;
			},
			skiResultsURL() {
				const classCode = this.classCode;
				const skiWorkspaceBack = this.skiWorkspaceBack;
				let route = '/assignments#!assignmentTab:rms/skiTab:about';

				if (skiWorkspaceBack && skiWorkspaceBack.href) {
					route = skiWorkspaceBack.href;
				} else if (classCode) {
					route += '/classCode:' + classCode;
				}
				return route;
			},
			languageOptions() {
				let selectedLanguage = this.selectedLanguage;
				const SKIKeys = Object.keys(SKILanguages);

				let options = SKIKeys.reduce((acc, key) => {
					let languageData = i18n.getLanguageSetRaw(key);
					let opt = null;
					if (languageData) {
						let value = languageData.languageCode;
						opt = {
							value,
							endonym: value !== 'en' ? languageData.endonym : null,
							displayValue: languageData.displayValue,
							selected: selectedLanguage === languageData.languageCode
						};
						acc.push(opt);
					}
					return acc;
				}, []);

				return options;
			},
			rtl() {
				let selectedLanguage = this.selectedLanguage;
				let languageData = i18n.getLanguageSetRaw(selectedLanguage);
				return languageData && languageData.rtl;
			},
			eventData() {
				let data = {};
				let selectedLanguage = this.selectedLanguage;
				if (selectedLanguage && selectedLanguage !== 'en') {
					data.lang = selectedLanguage;
				}
				return data;
			},
			needsGoogleAuth() {
				let token = this.localGCAccessToken;
				let skiAssignment = this.skiAssignment;
				/* No GCA check needed - inaccessible in GCA */

				return skiAssignment && skiAssignment.gcid && !token;
			}
		},
		methods: {
			onQuestionAnswer(ans, qid) {
				let skiAssignment = this.skiAssignment;
				let allQuestions = this.allQuestions;
				let question = allQuestions[qid];
				let currentAnswer = this.answers[qid];
				let answer = ans;

				if (question.type === 'multi') {
					if (currentAnswer && currentAnswer.length) {
						answer = currentAnswer.filter(a => a !== ans);
						if (answer.length === currentAnswer.length) {
							answer.push(ans);
						}
					} else {
						answer = [ans];
					}
				} else if (question.type === 'written') {
					if (ans && ans.length) {
						answer = ans;
					} else {
						answer = undefined;
					}
				}
				if (!this.isTeacher) {
					fireEvent(SKI_STUDENT_ANSWER_QUESTION, {
						rmsid: skiAssignment.rmsid,
						ans,
						qid
					});
				}
				this.answers = _.assign({}, this.answers, {
					[qid]: answer
				});
			},
			onShowTtsClick() {
				this.showTts = !this.showTts;
				fireEvent(WORKSPACE_TOOL_CLICK, {
					action_type: 'show_tts',
					state: this.showTts,
					tab: 'rms'
				});
			},
			onLanguageChange() {
				let language = this.selectedLanguage;
				this.loading = true;
				getSKIProduct(language).then(() => {
					fireEvent(WORKSPACE_TOOL_CLICK, {
						action_type: 'toggle_language',
						tab: 'rms',
						state: language
					});
					this.loading = false;
				});
			},
			onSubmit() {
				let ans = this.answers;
				let language = this.selectedLanguage !== 'en' ? this.selectedLanguage : undefined;
				let rmsid = this.skiAssignment ? this.skiAssignment.rmsid : null;
				let token = this.skiAssignment.gcid ? this.localGCAccessToken : undefined;

				this.loading = true;
				submitSKI(ans, language, rmsid, token)
					.then(() => {
						this.submitted = true;
						utilities.closeModals();

						scrollManager(0, {
							priority: 1
						});
						model.remove('skiAssignment');
					})
					.finally(() => (this.loading = false));
			},
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			},
			onPrintClick() {
				const { uid } = this.userContext;
				const cc = this.classCode;
				const section = this.skiProduct.title.toUpperCase().replace(/ /g, '_');

				fireEvent(PRINT, {
					cc,
					uid,
					section
				});
				window.print();
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		},
		watch: {
			skiProduct(product) {
				let answers = {};
				let numberOfQuestions = 0;
				let sections = null;
				let allQuestions = {};

				if (product && product.sections && product.sections.length) {
					sections = product.sections.map(section => {
						let updateSection = section;
						if (section.questions && section.questions.length) {
							let updatedQuestions = section.questions.map(question => {
								let id = question.id;
								answers[id] = null;
								let required = false;
								numberOfQuestions++;

								if (question.type === 'interest' || question.type === 'happiness') {
									required = true;
								}

								let q = _.assign({}, question, {
									required
								});

								allQuestions[id] = q;
								return q;
							});
							updateSection = _.assign({}, section, {
								questions: updatedQuestions
							});
						}
						return updateSection;
					});
				}

				this.answers = answers;
				this.sections = sections;
				this.numberOfQuestions = numberOfQuestions;
				this.allQuestions = allQuestions;
			}
		},
		beforeDestroy() {
			model.remove('skiWorkspaceBack');
		},
		mounted() {
			this.loading = true;
			let userContext = this.userContext;
			let selectedLanguage = i18n.defaultLanguage;
			if (userContext.ell && SKILanguages[userContext.ell]) {
				selectedLanguage = userContext.ell;
			}
			let promises = [getSKIProduct(selectedLanguage)];

			utilities.openModal('#modal-confirm-student-knowledge-inventory-begin');
			if (!this.hasAssignment) {
				promises.push(studentGetSKIAssignment());
			}

			Q.all(promises).then(() => {
				let product = this.skiProduct;
				let hasAssignment = this.hasAssignment;
				let isTeacher = this.isTeacher;
				let skiAssignment = this.skiAssignment;
				if (!product || !hasAssignment) {
					let route = '/student';
					if (isTeacher) {
						route = this.skiResultsURL;
					}
					page(route);
				} else {
					if (!isTeacher) {
						fireEvent(SKI_START, {
							rmsid: skiAssignment.rmsid
						});
					}
					this.loading = false;
				}
			});

			this.selectedLanguage = selectedLanguage;
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.student-knowledge-inventory-workspace {
		.main-content {
			max-width: 720px;
			margin: 0 auto;
		}

		.main {
			position: relative;

			.main-header-back {
				float: none;
			}

			.main-header-title-wrapper {
				display: flex;

				h1 {
					flex: 1;
				}
			}

			.language-select {
				margin-right: 1rem;

				.input-select {
					margin-bottom: 0;
				}
			}
		}

		.toolbar-button {
			max-height: 3.5rem;
		}

		.answer-guide {
			margin-top: 2rem;
		}

		.answer-guide-title {
			font-style: italic;
		}

		.answer-guide-question-options {
			.answer-guide-option {
				margin-bottom: 0.5rem;

				img {
					max-width: 2rem;
				}
			}
		}

		.section-body {
			margin-bottom: 3rem;
		}

		.survey-question-container {
			margin: 2.5rem 0;
		}

		.form-warning {
			color: $c-red;
			margin: 1rem 0;
		}

		.required {
			display: inherit;
		}

		@media print {
			font-size: 0.75rem;

			h2 {
				font-size: 1.25rem;
			}

			.ski-content h3 {
				margin-top: 0.75rem;
			}

			.section-body {
				margin-bottom: 1rem;
			}

			.answer-guide {
				margin-top: 0.5rem;
			}

			.survey-question-container {
				margin: 0.5rem 0;
				page-break-inside: avoid;
			}

			.answer-guide-question-options .answer-guide-option {
				margin-bottom: 0;
			}

			.answer-guide-option,
			.survey-question {
				img {
					height: 1rem;
				}
			}

			.survey-question {
				&.required .question-text:before {
					content: '';
				}

				&:not(.multi) .options {
					flex-direction: row;

					.option {
						width: 2rem;
						margin: 0;
						padding: 0;
						border: none;
					}
				}
			}
		}
	}

	.rtl {
		direction: rtl;
	}
</style>
<template>
	<div
		class="student-knowledge-inventory-workspace"
		@cut.prevent
		@copy.prevent
		@paste.prevent>
		<main
			id="content"
			class="main">
			<load-mask
				v-if="loading"
				class="align-top"></load-mask>
			<header class="main-header">
				<div class="print-only margin-bottom-medium">
					<strong>Name: __________________________________________________________ Date: _______________</strong>
				</div>
				<div class="wrapper">
					<div class="main-header-top">
						<a
							v-if="!isTeacher"
							class="main-header-back"
							href="/student">
							&larr; Assignments
						</a>
						<a
							v-if="isTeacher"
							class="main-header-back"
							:href="skiResultsURL">
							&larr; {{ (skiWorkspaceBack && skiWorkspaceBack.text) || 'Assignments' }}
						</a>
					</div>
					<div class="main-header-content">
						<div class="main-header-title-wrapper">
							<h1 class="main-header-title">{{ submitted ? 'Submitted!' : title }}</h1>
							<div class="select-container form language-select print-hidden">
								<div class="input-select">
									<select
										v-model="selectedLanguage"
										@change="onLanguageChange">
										<option
											v-for="option in languageOptions"
											:key="option.value"
											:value="option.value">
											{{ option.displayValue }}
											{{ option.endonym ? ' (' + option.endonym + ')' : '' }}
										</option>
									</select>
								</div>
							</div>
							<button
								class="button -outline toolbar-button tts"
								@click="onShowTtsClick"
								:class="{ '-active': showTts }"
								aria-label="Enable text-to-speech">
								<i
									class="fa-solid fa-volume-high"
									aria-hidden="true"></i>
							</button>
							<button
								class="button -outline toolbar-button print margin-left-medium"
								v-if="isTeacher"
								@click="onPrintClick"
								aria-label="Print">
								<i
									class="fa-solid fa-print"
									aria-hidden="true"></i>
							</button>
						</div>
					</div>
				</div>
			</header>
			<div
				class="main-content wrapper rte"
				:class="{
					rtl: rtl
				}">
				<section>
					<div
						v-if="!submitted"
						class="question-set">
						<form class="ski-content">
							<div
								v-for="(section, sectionIndex) in sections"
								:key="section.title ?? sectionIndex">
								<h2 v-if="section.title">
									{{ section.title }}
									<audio-player-simple
										v-if="showTts && section.titleAudio"
										:url="assetUrl(section.titleAudio)"
										:event-data="eventData">
									</audio-player-simple>
								</h2>
								<h3 v-if="section.subtitle">
									{{ section.subtitle }}
									<audio-player-simple
										v-if="showTts && section.subtitleAudio"
										:url="assetUrl(section.subtitleAudio)"
										:event-data="eventData">
									</audio-player-simple>
								</h3>
								<div
									v-if="section.answerGuide && section.answerGuide.questionTypes"
									v-for="questionType in section.answerGuide.questionTypes"
									:key="questionType"
									class="answer-guide">
									<div class="answer-guide-title">
										{{ questionTypes[questionType].title }}
										<audio-player-simple
											v-if="showTts && questionTypes[questionType].audio"
											:url="assetUrl(questionTypes[questionType].audio)"
											:event-data="eventData">
										</audio-player-simple>
									</div>
									<div class="answer-guide-question-options">
										<div
											v-for="option in questionTypes[questionType].options"
											:key="option.text"
											class="answer-guide-option">
											<img :src="assetUrl(option.img)" /> = {{ option.text }}
										</div>
									</div>
								</div>
								<div
									v-if="section.questions"
									class="section-body">
									<div
										class="survey-question-container"
										v-for="question in section.questions"
										:key="question.id">
										<survey-question
											:qid="question.id"
											:type="question.type"
											:value="answers[question.id]"
											:text="question.text"
											:audio="question.audio"
											:options="question.options"
											:required="question.required"
											:on-question-answer="onQuestionAnswer"
											:question-types="questionTypes"
											:show-audio="showTts"
											:placeholder="question.placeholder"
											:audio-event-data="eventData">
										</survey-question>
									</div>
								</div>
							</div>
						</form>
						<div class="text-centered">
							<div
								class="form-warning print-hidden"
								v-if="hasUnansweredQuestions">
								{{ unansweredQuestionsData.text }}
								<audio-player-simple
									v-if="showTts && unansweredQuestionsData.audio"
									:url="assetUrl(unansweredQuestionsData.audio)"
									:event-data="eventData">
								</audio-player-simple>
							</div>
							<button
								class="button centered"
								type="submit"
								:disabled="hasUnansweredQuestions"
								data-modal="#modal-confirm-student-knowledge-inventory-submit">
								Submit
							</button>
						</div>
					</div>
					<div
						v-if="submitted"
						class="text-centered">
						{{ postSubmissionData.text }}
						<audio-player-simple
							v-if="showTts && postSubmissionData.audio"
							:url="assetUrl(postSubmissionData.audio)"
							:event-data="eventData">
						</audio-player-simple>
						<p class="text-centered">
							<a
								class="button"
								href="/student">
								Back to Assignments
							</a>
							<a
								href="/logout"
								class="button">
								Logout
							</a>
						</p>
					</div>
				</section>
			</div>
		</main>
		<modal
			id="modal-confirm-student-knowledge-inventory-submit"
			:loading="loading">
			<template slot="header-container">
				<h2>Submit Survey</h2>
			</template>
			<div slot="content">
				<template v-if="isTeacher">
					<p class="text-centered">You've completed your preview. Click below to return to Class Admin.</p>
					<p class="text-centered">
						<a
							:href="skiResultsURL"
							class="button -outline">
							{{ (skiWorkspaceBack && skiWorkspaceBack.text) || 'Assignments' }}
						</a>
					</p>
				</template>
				<template v-if="!isTeacher">
					<p class="text-centered">Are you sure you want to submit?</p>
					<p
						v-if="needsGoogleAuth"
						class="text-centered">
						<span
							class="button"
							@click.stop="authenticateWithGoogle">
							Authenticate with Google
						</span>
					</p>
					<p class="text-centered">
						<button
							class="button"
							:disabled="needsGoogleAuth"
							@click="onSubmit">
							Yes
						</button>
						<button
							data-modal-close
							class="button -outline">
							Not Yet
						</button>
					</p>
				</template>
			</div>
		</modal>
		<modal id="modal-confirm-student-knowledge-inventory-begin">
			<template slot="header-container">
				<h2>Ready to Start?</h2>
			</template>
			<div slot="content">
				<p>Once you start you will have to finish and submit.</p>
				<p>Ready to start?</p>
				<p class="text-centered">
					<button
						data-modal-close
						class="button">
						Yes
					</button>
					<a
						href="/student"
						v-if="!isTeacher">
						<button class="button -outline">Not Yet</button>
					</a>
					<a
						:href="skiResultsURL"
						v-if="isTeacher">
						<button class="button -outline">Not Yet</button>
					</a>
				</p>
			</div>
		</modal>
	</div>
</template>
